import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'

// components
import Title from '@/components/onepager/sections/Title'
import ShortTextDisplay from '@/components/onepager/sections/_shorttext/display'

function ShortText({ id, contentID, sectionData, wrapperId }) {
  return (
    <div className="relative h-full innerBox">
      {/* image background test */}
      {/* <div className="absolute opacity-10 top-0 left-0 h-full w-full">
        <img
          src="https://images.unsplash.com/photo-1569091923578-399adee3f634?ixid=MXwxMjA3fDB8MHxzZWFyY2h8M3x8b2NlYW58ZW58MHx8MHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=60"
          alt="test"
        />
      </div> */}

      <Title
        id={id}
        title={sectionData.title}
        prompt={sectionData.prompt}
        wrapperId={wrapperId}
      />
      <div className="boxBody">
        <ShortTextDisplay id={contentID} sectionData={sectionData.data} />
      </div>
    </div>
  )
}

export default ShortText
